export default __webpack_public_path__ + "static/media/Snd_Backdown.086f3815.mp3";